var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{staticClass:"telegram"},[_c('iframe',{staticClass:"telegram-widget",attrs:{"src":"https://goverla.ua/telegram","id":"tg-if"},on:{"load":_vm.stylize}})])}
var staticRenderFns = []

export { render, staticRenderFns }